// removed by extract-text-webpack-plugin
module.exports = {"smallDeviceMax":"567px","mediumDeviceMin":"568px","mediumDeviceMax":"991px","largeDeviceMin":"992px","large_device_min_alt":"1350px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Dropdown/DropdownWrapper.css
// module id = 1097
// module chunks = 1